{
    "logos": {
        "logo": "https://receeto.com/assets/fake-db/images/logo.webp",
        "white_logo": "https://receeto.com/assets/fake-db/images/logo_white.webp"
    },
    "contact_info": {
        "email": "contact@receeto.com",
        "phone_number": "+216 94 519 633"
    },
    "social_media": {
        "linkedin_link": "https://www.linkedin.com/company/receeto/",
        "facebook_link": "https://www.facebook.com/profile.php?id=61559499166253&mibextid=qi2Omg&rdid=GwkAxFWBnsmfIOVV&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1HTZrUUEnH%2F%3Fmibextid%3Dqi2Omg#",
        "instagram_link": "https://www.instagram.com/receeto?igsh=ZzdzbHkyOWVxcWt0",
        "tiktok_link": null,
        "youtube_link": null,
        "whatsapp_link": null
    },
    "hostinger_link": "https://www.hostinger.com/?REFERRALCODE=1RECEETO88"
}